<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="main-fad-personal">
            <h1>
                <p>FAD® PESSOAL</p>
            </h1>
        </div>

        <div class="you-should">
            <div class="container max-width">
                <div class="picture">
                    <img src="assets/images/suscripciones.png" alt="Suscripciones">
                </div>
                <div class="text">
                    <h2><p class="principal">
                        Com FAD® pessoal <br>você pode escolher o
                        <br><span>plano mensal<br>ou pré-pago com<br>validade anual:</span>
                    </p></h2>
                    <p class="secondary">
                        Você pode cancelar o plano mensal a qualquer momento.
                    </p>
                </div>
            </div>
        </div>

        <div class="options-suscriptions">
            <div class="container max-width">
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/suscripcion_mensual.png" alt="FAD Personal">
                            <div class="text">
                                <p>Plano <br> <span>mensal</span></p>
                            </div>
                        </div>
                        <mat-card-content>
    
                            <div class="characteristic">
                                <p class="light">
                                    Número de transações:
                                </p>
                                <p class="bold">
                                    Assinaturas ilimitadas
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Suporte:
                                </p>
                                <p class="bold">
                                    N1 Call center de segunda a sexta das 8h às 20h.
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Inclui:
                                </p>
                                <p class="bold">
                                    Apenas aplicativo nativo (iOS e Android)
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transação:
                                </p>
                                <p class="bold">
                                    Vídeo Assinatura + vídeo de aceitação do acordo + constância de conservação +
                                    verificação por número de telefone
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Com custo extra
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Forma de pagamento:
                                </p>
                                <p class="bold">
                                    Cartão de crédito ou débito
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_mensual_personal" class="option no-cart dark" (click)="callForm(6)">
                            <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/suscripcion_anual.png" alt="FAD Personal">
                            <div class="text">
                                <p>Pré-pago com<br><span>Validade anual</span></p>
                            </div>
                        </div>
                        <mat-card-content>
      

                            <div class="characteristic">
                                <p class="light">
                                    Usuários incluídos
                                </p>
                                <p class="bold">
                                    1
                                    <br>Usuário
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Número de transações:
                                </p>
                                <p class="bold">
                                    Planos de 10, 20, 50, 100, 200, 500 ou 1.000 assinaturas
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Validade das transações:
                                </p>
                                <p class="bold">
                                    Anual
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transação:
                                </p>
                                <p class="bold">
                                    Vídeo Assinatura + vídeo de aceitação do acordo + constância de conservação +
                                    verificação por número de telefone
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Com custo extra
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Forma de pagamento:
                                </p>
                                <p class="bold">
                                    Cartão de crédito ou débito
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_anual_personal" class="option no-cart dark" (click)="callForm(7)">
                            <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="add-ons">
            <p class="title max-width">
                Tanto no Plano Mensal quanto no Pré-pago,<br>
                você pode adicionar as seguintes <span>Funções extras (Add-Ons) **:</span>
            </p>
            <p style="margin: 20px 0 0; text-align: center; font-size: 20px; margin-top: -15px;">
                <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital." style="font-weight: bold;color: var(--light-gray-color); text-decoration: none; cursor: pointer;">** Para a compra de funcionalidades extras (Add-Ons) solicite-as ao seu consultor de vendas a um custo extra.</a>
            </p>
            <div class="list max-width">
                <div class="left">
                    <p class="title">
                        Recursos extras
                    </p>
                    <div class="table">

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/foto_ine.png" alt="Foto INE">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação</p>
                                <p class="text-item">Fotografia de identificação em ambos os lados</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/otp_whatsap.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">OTP via WhatsApp</p>
                                <p class="text-item">Envio de código único pelo WhatsApp, para que o signatário abra o
                                    documento a ser assinado no aplicativo móvel ou web</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/blockchain.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Constância de conservação em Blockchain</p>
                                <p class="text-item">Certificado registrado em Ethereum que garante que o documento assinado não será alterado</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/version_web.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Versão WEB</p>
                                <p class="text-item">O signatário pode assinar documentos de qualquer navegador móvel sem baixar nenhum aplicativo</p>
                            </div>
                        </div>


                        <div class="row">
                            <div class="image">
                                <img src="assets/images/fotoine_firma.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura</p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura + comparação
                                    facial com vídeo de aceitação do acordo</p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch, além de uma comparação entre a foto do rosto
                                    no documento de identidade e uma imagem do rosto do signatário durante o vídeo de
                                    aceitação do acordo</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_videofirma.png" alt="Ine, video y firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura + comparação
                                    facial com vídeo assinatura </p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch, além de uma comparação entre a foto do rosto
                                    capturada no documento de identidade e uma imagem do rosto do signatário durante a
                                    vídeo assinatura</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video_validacion.png"
                                     alt="Ine, comparación de firma y video firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura + comparação
                                    facial com vídeo de aceitação do acordo + comparação facial com vídeo assinatura</p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch; comparação entre a foto do rosto capturada no
                                    documento de identidade e uma imagem do rosto do signatário durante o vídeo
                                    aceitação do acordo; comparação entre a foto do rosto capturada no documento de
                                    identidade e uma imagem do rosto do signatário durante a vídeo assinatura</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="do-you-wish">
            <p class="title max-width">
                Quer adquirir um <span>Plano Mensal</span><br> ou <span>Pré-pago?</span>
            </p>
            <div class="options max-width">
                <div class="item">
                    <img src="assets/images/suscripcion_mensual_personal.png" alt="Suscripción Mensual">
                    <div class="text">
                        <p>Preço do<br><span>plano mensal </span></p>
               </div>
                </div>

                <div class="item">
                    <img src="assets/images/suscripcion_anual_2.png" alt="Suscripción Anual">
                    <div class="text">
                        <p>Pré-pago com <br><span>validade anual</span></p>
               </div>
                </div>
            </div>
        </div>
        <div class="pricing-list-bottom">
            <div class="container max-width">
                <div class="item">
                    <div id="comprar_mensual_resumen" class="option no-cart dark" (click)="callForm(6)">
                        <p>COTIZA HOY</p>
                    </div>
                </div>
                <div class="item">
                    <div id="comprar_anual_resumen" class="option no-cart dark" (click)="callForm(7)">
                        <p>COTIZA HOY</p>
                    </div>
                </div>
            </div>
        </div>
        <div id="contact-cotizar"><p style="color: white;">ancla</p></div>
        <div>
            <div class="options-suscriptions-form" *ngIf="contactForm === 6 || contactForm === 7">
                <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                <p class="title max-width" *ngIf="contactForm === 6">
                    Preencha esse formulário para  <b>fazer o orçamento do<br>seu plano de assinatura mensal</b>
                </p>
                <p class="title max-width" *ngIf="contactForm === 7">
                    Preencha esse formulário para <b>fazer o orçamento seu<br>plano pré-pago com validade anual</b>
                </p>
                <div class="max-width" *ngIf="contactForm === 6">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
                <div class="max-width" *ngIf="contactForm === 7">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/personalfotos.png">
            </div>

            <div class="content-res">
                <h1>FAD®<br><span>PESSOAL</span><br></h1>
                <hr>
                <h2><p class="text">
                    Com FAD® pessoal você pode<strong> escolher o plano mensal ou pré-pago com validade anual</strong> e você pode cancelar o plano mensal a qualquer momento.
                </p></h2>
                <br>
            </div>

            <div class="box-light">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Plano</p><span>mensal</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">
            
                            <p>Assinatura de vídeo + contrato de vídeo<br>+ CC NOM 151-2016</p>
                            <p>N1 Call center de segunda a sexta das 8h às 20h.</p>
                            <p>Apenas aplicativo nativo</p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_mensual_personal_movil" class="btn-back" (click)="callForm(6)">
                                <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Plano pré-pago</p>
                        <span>com validade anual</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">
               
                            <p>Transações<br><strong>10, 20, 50, 100, 500 o 1000</strong></p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_anual_personal_movil" class="btn-back" (click)="callForm(7)">
                                <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-general">


                <div class="content-res">
                    Conheça as<br><strong>funcionalidades<br>extras do FAD®</strong><br>
                </div>

                <div class="icon">
                    <div class="icon2"></div>
                </div>
                <p class="text"><span>Validação de vídeo de aceitação do acordo</span>
                    <br>Comparação entre o rosto durante o contrato de vídeo e a foto de identificação</p>

                <div class="icon">
                    <div class="icon3"></div>
                </div>
                <p class="text"><span>Validação de Vídeo assinatura </span>
                    <br>Comparação entre o rosto durante a vídeo assinatura e a foto do documento de identidade</p>

                <div class="icon">
                    <div class="icon4"></div>
                </div>
                <p class="text"><span>Constância de blockchain</span>
                    <br>Em Ethereum que garante que o documento assinado não será alterado</p>

                <div class="icon">
                    <div class="icon5"></div>
                </div>
                <p class="text"><span>Captura de identidade</span>
                    <br>Fotografia do documento de identidade em ambos os lados</p>

                <div class="icon">
                    <div class="icon6"></div>
                </div>
                <p class="text"><span>OTP via WhatsApp</span>
                    <br>Envio de código único pelo WhatsApp, para que o signatário abra o documento a ser assinado no
                    app FAD®</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Validação de assinatura</span>
                    <br>Comparação entre a assinatura no documento de identidade e a assinatura feita com o dedo</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Versão WEB</span>
                    <br>O signatário pode assinar documentos de qualquer navegador móvel sem baixar nenhum aplicativo</p>

                <div class="icon">
                    <div class="icon20"></div>
                </div>
                <p class="text"><span style="color: #a80a34;">Considerações importantes</span>
                    <br>1. Para fazer comparações de contrato de vídeo, assinatura de vídeo e assinatura, é necessário
                    adquirir a Captura de Identificação.<br>
                    2. Para adquirir Add-Ons, solicite-os com seu consultor de vendas por um custo extra.</p>

                <img height="330px" width="266px" src="assets/images/m/telefonos.png" alt="">

            </div>

            <div class="box-light-fondo">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 10px;">
                        <p class="light">
                            Quer adquirir um <span>plano</span> mensal ou <span>Pré-pago?</span></p>
                    </div>
                    <div class="box-product">
                        <div class="content-res" style="padding-bottom: 10px;">
                            <p class="light" style="margin-bottom: 0px;">Plano </p><span>mensal</span>
                        </div>
                        <div class="buttons">
                            <div id="comprar_mensual_resumen_movil" class="btn-back" (click)="callForm(6)">
                                <p>COTIZA HOY</p>
                            </div>
                        </div>
                    </div>
                    <div class="box-product">
                        <div class="content-res" style="padding-bottom: 10px;">
                            <p class="light" style="margin-bottom: 0px;">
                                Plano pré-pago com <span>validade anual</span></p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_anual_resumen_movil" class="btn-back" (click)="callForm(7)">
                                <p>COTIZA HOY</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="contact-cotizar-movil">
            <div class="content-general-form" *ngIf="contactForm === 6 || contactForm === 7">
                <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                <div class="content-res-form" *ngIf="contactForm === 6">
                    <p class="title">
                        Preencha esse formulário para  <strong>fazer o orçamento do<br>seu plano de assinatura mensal</strong>
             
                </div>
                <div class="content-res-form" *ngIf="contactForm === 7">
                    <p class="title">
                        Preencha esse formulário para <strong>fazer o orçamento seu<br>plano pré-pago com validade anual</strong>
                    </p>
                </div>
                <div class="content-res-form" *ngIf="contactForm === 6">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
                <div class="content-res-form" *ngIf="contactForm === 7">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
            </div>
        </div>
    </div>

</app-template>
